module.exports = __webpack_public_path__ + "img/consultWhite.04dbc359.jpg";